import moment from 'moment';
import {
  PATH_STRING_SEPARATOR
} from '../common/config.js';
import {
  IncidentsModalController
} from './add-to-incidents/incidents-modal.component';

export function FactTableRowComponent($compile) {
  return {
    restrict: 'A',
    scope: {
      filter: '=',
      fact: '=',
      openImage: '=',
      listType: '=',
      select: '='
    },
    controller: function(
      $scope,
      $element,
      $timeout,
      RouterService,
      AlertModalService,
      $modal,
      $http,
      FaceService
    ) {
      $scope.router = RouterService;
      $scope.AlertModalService = AlertModalService;
      $scope.sep = PATH_STRING_SEPARATOR;
      $scope.toUserNearestScreenshot = () => {
        $scope.router.needToShowFact = {
          needShowScreenshot: false,
          fact: $scope.fact,
          date: $scope.fact.local_time
        };
        $scope.router.toUserNearestScreenshot();
        $scope.router.filterChanged();
      };

      $scope.addToIncidents = () => {
        // console.log($scope.fact);
        $scope.modalInstance = $modal
          .open({
            template: require('./add-to-incidents/incidents-modal.component.html'),
            controller: IncidentsModalController,
            scope: $scope,
          })
          .result.then(() => {
            // console.log(res);
          }, err => {
            $scope.AlertModalService.open(`${err.status} ${err.status ? err.statusText :''}`, err.data);
          });
      };

      $scope.toNeighbourEvents = () => {
        $scope.router.needToShowFact = {
          fact: $scope.fact,
          date: $scope.fact.local_time
        };
        $scope.router.toNeighbourEvents();
        $scope.router.filterChanged();
      };

      $scope.findSimular = () => {
        $scope.router.findSimular($scope.fact.id);
      };

      $scope.printerExport = () => {
        window.open('/analytics/printer/export/' + $scope.fact.id, '_blank');
      };

      $scope.openFace = (fact, index) => {
        FaceService.openFace(fact, index);
      };

    },

    link: function(scope, element, attrs) {
      if (!scope.fact) return '';
      const noAddMenu =
        scope.filter.toExcel && scope.filter.toExcel.convertToExel;
      scope.viewMode = scope.$parent.viewMode;
      const colQty = scope.viewMode.columns.length;
      const widget = scope.viewMode.columns
        .map((colView, c) => {
          let table = element.parent();
          while (
            table &&
            table[0].nodeName.toLowerCase() !== 'sc-facts-table'
          ) {
            table = table[0] === document.body ? null : table.parent();
          }
          if (!table) {
            return;
          }
          const thSelector = table.find('.fact-table th:visible');
          const th = thSelector[c];
          const setWidth = th ? getComputedStyle(th).width : 0;
          const lastCol = !scope.router.isFilterEditModal && c === colQty - 1;

          let findSimularElem = '';
          if (!noAddMenu && scope.fact.text_data && lastCol) {
            findSimularElem = `
          <li >
            <a ng-click="findSimular()"> ${gettext(
              'Найти похожие документы'
            )}</a>
          </li>`;
          }

          const event_type = scope.fact['agent_eventtype.id'];

          if (!noAddMenu && event_type == 11 && lastCol) {
            findSimularElem += `
          <li >
            <a ng-click="printerExport()" target="_new"> ${gettext(
              'Экспорт в PDF'
            )}</a>
          </li>`;
          }

          let lastMenuElem = '';
          if (!noAddMenu && lastCol) {
            lastMenuElem = `<span class="dropdown to-screenshot">
          <i data-toggle="dropdown"
            ng-if="true"
            class="icon-wrench dropdown-toggle"
          ></i>
          <ul class="dropdown-menu pull-right" sc-ul>
            <li >
              <a ng-click="toUserNearestScreenshot()">${gettext(
                'К ближайшему снимку с экрана'
              )}</a>
            </li>
            <li >
              <a ng-click="toNeighbourEvents()">${gettext('События рядом')}</a>
            </li> ${findSimularElem}
            <li >
              <a ng-click="addToIncidents()">${gettext(
                'Добавить событие в инцидент'
              )}</a>
            </li>
          </ul>
        </span>`;
          }

          return `<td class="${
            colView['cssClass'] ? colView['cssClass'] : ''
          } rc-${c} style="width:${setWidth}"> ${colView.parse(
            scope.fact,
            'short'
          )} ${lastMenuElem}</td>`;
        })
        .join('', '');
      element.append(widget);
      $compile(element.contents())(scope);
    }
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-table-row.component.js